"use client";

import Loader from "@/components/Loader";
import { useRobot } from "@/hooks/useRobot";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useSupabase } from "@/app/supabase-provider";
import { IRobot } from "@/types/robot";
import { WatcherStepForm, WatcherStepsField } from "../[id]/steps/form";
import { useRouter } from "next/navigation";
import { WatcherFormField } from "@/components/Form";
import { Button } from "flowbite-react";
import { useUser } from "@/hooks/useUser";

export default function RobotCreate({ params }: { params: { id: string } }) {
  const { supabase } = useSupabase();
  const { data: user } = useUser();
  const router = useRouter();

  const methods = useForm({
    defaultValues: {
      steps: [],
      name: "",
      initialUrl: "",
    },
  });

  const { handleSubmit } = methods;

  const onSubmit = async (values: Partial<IRobot>) => {
    const { data: created } = await supabase
      .from("watcher_robots")
      .insert({
        ...values,
        user_id: user?.id,
      })
      .select();
    const createdRobot = created?.[0];
    if (createdRobot as IRobot) {
      router.push(`/dashboard/robots/${createdRobot.id}/start`);
    }
  };

  return (
    <div className="w-full max-w-4xl">
      <div className="flex flex-col gap-3 pt-3">
        <FormProvider {...methods}>
          <form
            className="flex flex-col gap-8 pt-5"
            onSubmit={handleSubmit(onSubmit)}
          >
            <WatcherFormField
              type="textarea"
              key="name"
              label="Robot Name"
              fieldKey="name"
              validation={{
                required: true,
              }}
            />
            <WatcherFormField
              type="textarea"
              key="initialUrl"
              label="Robot Initial Url"
              fieldKey="initialUrl"
              validation={{
                required: true,
              }}
            />
            <WatcherStepsField />

            <div className="flex flex-row justify-end">
              <Button type="submit">Create Robot</Button>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
}
